import isWeb from './isWeb'

export default function (h) {
  return isWeb ? `${h}px` : h
}
